<template>
  <section>
    <!-- Menu -->
    <top-menu/>

    <section>
      <page-header :headerName="'Histórico de Tags'" :showBtn="false" :btnName="''" :btnRoute="''"
                   :css="'container-fluid'"/>

      <div class="page-content">
        <div class="container-fluid">
          <div class="row">
            <!-- Loading -->
            <full-loading v-if="loadingList"/>

            <!-- Filters -->
            <div class="col-xs-12 col-sm-12 col-md-12">
              <div v-if="!loadingList" class="col-xs-12 col-sm-12 col-md-12 default-box filters">
                <div class="col-xs-12 col-sm-12 col-md-12">
                  <div class="col-xs-12 col-sm-6 col-md-3">
                    <div class="form-group">
                      <label>Empresa (CompanyId)</label>
                      <input type="text" v-model="dataSearch.companyId" class="form-control"
                             placeholder="Id da empresa">
                    </div>
                  </div>
                  <div class="col-xs-12 col-sm-6 col-md-3">
                    <div class="form-group">
                      <label>Tag</label>
                      <select v-model="dataSearch.tagId" class="form-control">
                        <option value="">Todas</option>
                        <option v-for="t in tags" :key="t.id" :value="t.id">
                          {{ t.name }}{{ t.isSystemTag ? ' (sistema)' : '' }}
                        </option>
                      </select>
                    </div>
                  </div>
                  <div class="col-xs-12 col-sm-6 col-md-2">
                    <div class="form-group">
                      <label>Ação</label>
                      <select v-model="dataSearch.action" class="form-control">
                        <option value="">Todas</option>
                        <option value="Assigned">Atribuída</option>
                        <option value="Unassigned">Desatribuída</option>
                        <option value="StillMatching">Ainda inconsistente</option>
                        <option value="TagCreated">Tag criada</option>
                        <option value="TagUpdated">Tag editada</option>
                        <option value="TagDeleted">Tag excluída</option>
                      </select>
                    </div>
                  </div>
                  <div class="col-xs-12 col-sm-6 col-md-2">
                    <div class="form-group">
                      <label>Início</label>
                      <datepicker v-model="dataSearch.init" :language="ptBR" :format="customFormatter"
                                  placeholder="Início"/>
                    </div>
                  </div>
                  <div class="col-xs-12 col-sm-6 col-md-2">
                    <div class="form-group">
                      <label>Fim</label>
                      <datepicker v-model="dataSearch.end" :language="ptBR" :format="customFormatter"
                                  placeholder="Fim"/>
                    </div>
                  </div>
                  <div class="col-xs-12 col-sm-6 col-md-3">
                    <div class="form-group">
                      <label>Usuário (UserId)</label>
                      <input type="text" v-model="dataSearch.byUserId" class="form-control"
                             placeholder="Quem fez">
                    </div>
                  </div>
                  <div class="col-xs-12 col-sm-6 col-md-2">
                    <div class="form-group">
                      <label>Página</label>
                      <input type="number" min="1" v-model.number="dataSearch.page" class="form-control">
                    </div>
                  </div>
                  <div class="col-xs-12 col-sm-6 col-md-2">
                    <div class="form-group">
                      <label>Itens por página</label>
                      <input type="number" min="10" max="1000" v-model.number="dataSearch.pageSize"
                             class="form-control">
                    </div>
                  </div>
                </div>
                <div class="col-xs-12 col-sm-12 col-md-12">
                  <button v-on:click="getHistory()">Pesquisar</button>
                  <button v-on:click="clearFilters()" class="btn-secondary" style="margin-left:8px;">Limpar
                    filtros
                  </button>
                  <button v-on:click="runRoutines()" class="btn-warning" style="margin-left:8px;"
                          title="Roda agora as rotinas automáticas de tags de sistema (anual vencido, MRR divergente)">
                    Rodar rotinas de tags
                  </button>
                </div>
              </div>
            </div>

            <!-- Empty -->
            <div v-if="!loadingList && historyItems !== '' && !historyItems.length && !failRequest"
                 class="col-xs-12 col-sm-12 col-md-12">
              <div class="col-xs-12 col-sm-12 col-md-12 default-box content-default">
                <p>Sem resultados para os filtros informados.</p>
              </div>
            </div>

            <!-- Fail -->
            <div v-if="!loadingList && failRequest" class="col-xs-12 col-sm-12 col-md-12">
              <div class="col-xs-12 col-sm-12 col-md-12 default-box content-default">
                <p>Falha na requisição.</p>
              </div>
            </div>

            <!-- Table -->
            <div v-if="!loadingList && historyItems.length" class="col-xs-12 col-sm-12 col-md-12">
              <div class="col-xs-12 col-sm-12 col-md-12 default-box orderBy">
                <div class="portlet-title">
                  <div class="caption">
                    <span class="caption-subject font-blue bold uppercase">
                      Eventos encontrados ({{ historyItems.length }})
                    </span>
                  </div>
                </div>

                <div class="portlet-body contate-table offset-top-20">
                  <div class="table-scrollable table-scrollable-borderless">
                    <table class="table table-hover table-light table-icon">
                      <thead>
                      <tr>
                        <th>DATA</th>
                        <th>AÇÃO</th>
                        <th>TAG</th>
                        <th>EMPRESA</th>
                        <th>QUEM FEZ</th>
                        <th>NOTAS</th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr v-for="h in historyItems" :key="h.id">
                        <td>{{ formatDate(h.createdAt) }}</td>
                        <td>
                          <span class="tag-action" :class="actionClass(h.action)">
                            {{ actionLabel(h.action) }}
                          </span>
                        </td>
                        <td>{{ h.tagNameSnapshot }}</td>
                        <td>
                          <span v-if="h.companyId">{{ h.companyId }}</span>
                          <span v-else class="text-muted">—</span>
                        </td>
                        <td>
                          <span v-if="h.isSystemAction" class="tag-system">Sistema</span>
                          <span v-else>
                            {{ h.byUserName || h.byUserId || '—' }}
                          </span>
                        </td>
                        <td>{{ h.notes }}</td>
                      </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </section>
  </section>
</template>

<script>
import topMenu from "../../components/default/topMenu.vue";
import fullLoading from "../../components/default/fullLoading.vue";
import pageHeader from "../../components/default/pageHeader.vue";
import ptBR from "vuejs-datepicker/dist/locale/translations/pt-BR";
import datepicker from 'vuejs-datepicker';
import swal from 'sweetalert';
import moment from 'moment';

import {
  COMPANY_TAGS,
  COMPANY_TAGS_HISTORY,
  SYSTEM_TAGS_RUN_ROUTINES
} from "../../../../urlConfig";
import {REQUEST_SERVICE, UTIL_SERVICE} from "../../../../requestConfig";

// FB8c - tela de auditoria das operações de tags. Lista eventos do
// db.CompanyTagHistory no banco MarQAuth. Filtros opcionais por empresa,
// tag, ação, intervalo de data e usuário. Inclui um botão para rodar as
// rotinas de tags de sistema sob demanda (FB8b).
export default {
  name: "tag-history",
  components: {topMenu, pageHeader, fullLoading, datepicker},
  data() {
    return {
      ptBR: ptBR,
      loadingList: false,
      failRequest: false,
      historyItems: '',
      tags: [],
      dataSearch: {
        companyId: '',
        tagId: '',
        action: '',
        init: '',
        end: '',
        byUserId: '',
        page: 1,
        pageSize: 100
      }
    }
  },
  mounted() {
    this.loadTags();
    this.getHistory();
  },
  methods: {
    customFormatter(date) {
      return moment(date).format('DD/MM/YYYY');
    },
    formatDate(d) {
      if (!d) return '';
      return moment(d).format('DD/MM/YYYY HH:mm');
    },
    actionLabel(a) {
      switch (a) {
        case 'Assigned':
          return 'Atribuída';
        case 'Unassigned':
          return 'Desatribuída';
        case 'StillMatching':
          return 'Ainda inconsistente';
        case 'TagCreated':
          return 'Tag criada';
        case 'TagUpdated':
          return 'Tag editada';
        case 'TagDeleted':
          return 'Tag excluída';
        default:
          return a || '—';
      }
    },
    actionClass(a) {
      switch (a) {
        case 'Assigned':
          return 'tag-action-assigned';
        case 'Unassigned':
          return 'tag-action-unassigned';
        case 'StillMatching':
          return 'tag-action-still';
        case 'TagCreated':
          return 'tag-action-created';
        case 'TagUpdated':
          return 'tag-action-updated';
        case 'TagDeleted':
          return 'tag-action-deleted';
        default:
          return '';
      }
    },
    loadTags() {
      REQUEST_SERVICE.get(COMPANY_TAGS).then((response) => {
        this.tags = response.data || [];
      }).catch(() => {
        // sem tags não é fatal para a tela; só não vai ter o select populado
      });
    },
    clearFilters() {
      this.dataSearch = {
        companyId: '', tagId: '', action: '',
        init: '', end: '', byUserId: '',
        page: 1, pageSize: 100
      };
      this.getHistory();
    },
    buildQuery() {
      const q = [];
      const s = this.dataSearch;
      if (s.companyId) q.push("companyId=" + encodeURIComponent(s.companyId));
      if (s.tagId) q.push("tagId=" + encodeURIComponent(s.tagId));
      if (s.action) q.push("action=" + encodeURIComponent(s.action));
      if (s.init) q.push("init=" + moment(s.init).format("YYYY-MM-DD"));
      if (s.end) q.push("end=" + moment(s.end).format("YYYY-MM-DD"));
      if (s.byUserId) q.push("byUserId=" + encodeURIComponent(s.byUserId));
      if (s.page && s.page > 0) q.push("page=" + s.page);
      if (s.pageSize && s.pageSize > 0) q.push("pageSize=" + s.pageSize);
      return q.length ? '?' + q.join('&') : '';
    },
    getHistory() {
      this.loadingList = true;
      this.failRequest = false;

      const url = COMPANY_TAGS_HISTORY + this.buildQuery();
      UTIL_SERVICE.console("URL TAG HISTORY:", url);

      REQUEST_SERVICE.get(url).then((response) => {
        this.historyItems = response.data || [];
        this.loadingList = false;
      }).catch((reason) => {
        this.loadingList = false;
        this.failRequest = true;
        this.historyItems = [];
        if (reason && reason.response && reason.response.data && reason.response.data.erros) {
          reason.response.data.erros.forEach((value) => swal("Aviso", value.value, "error"));
        }
      });
    },
    runRoutines() {
      swal({
        title: "Rodar rotinas de tags?",
        text: "Vai reconciliar as tags de sistema (anual vencido e MRR divergente). Pode demorar um pouco. Continuar?",
        icon: "info",
        buttons: ["Cancelar", "Rodar"],
      }).then((ok) => {
        if (!ok) return;

        this.loadingList = true;
        REQUEST_SERVICE.post(SYSTEM_TAGS_RUN_ROUTINES, {}).then((response) => {
          this.loadingList = false;
          const results = response.data || [];
          const msg = results.map(r =>
            `${r.tagName}: matched=${r.matched}, assigned=${r.assigned}, unassigned=${r.unassigned}, ainda inconsistente=${r.stillMatching}`
          ).join('\n');
          swal("Rotinas executadas", msg || "Sem alterações.", "success");
          this.getHistory();
        }).catch(() => {
          this.loadingList = false;
          swal("Erro", "Falha ao rodar as rotinas.", "error");
        });
      });
    }
  }
}
</script>

<style lang="scss" scoped>
.tag-action {
  padding: 2px 8px;
  border-radius: 10px;
  font-size: 11px;
  font-weight: 600;
  color: #fff;
  white-space: nowrap;
}

.tag-action-assigned {
  background: #16a34a;
}

.tag-action-unassigned {
  background: #6b7280;
}

.tag-action-still {
  background: #8b5cf6; /* roxo - "ainda inconsistente" */
}

.tag-action-created {
  background: #2563eb;
}

.tag-action-updated {
  background: #d97706;
}

.tag-action-deleted {
  background: #dc2626;
}

.tag-system {
  background: #111827;
  color: #fff;
  padding: 2px 6px;
  border-radius: 4px;
  font-size: 11px;
}

.text-muted {
  color: #9ca3af;
}
</style>



// WEBPACK FOOTER //
// src/vue/pages/restricted/logPoint/tagHistory.vue